export const BASE_URL: string =  process.env.REACT_APP_API_URL || 'https://ratesapi.mycontainers.ru';
export const CONFIG: object = {
    headers: {
        'Content-Type': 'application/json; charset=utf-8',
    },
    withCredentials: true,
};
export const TOKEN_EXPIRES_TIME = 604800;